import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { v4 as uuidv4 } from 'uuid';
import { Button } from '../../../ui/Button';
import PoweredByZillowBadge from 'app/shared/modules/PoweredByZillowBadge';
import pathsManifest from 'app/shared/utils/pathsManifest';
import { emitTrackRentalAppPreStartEvent } from 'app/shared/models/Clickstream/HdpClickstreamEvents';
import constants from 'app/shared/constants/ExperimentConstants';
import type { RootReduxState } from 'app/shared/flux/reducers';
import Illustration from 'images/applications-group-illustration.svg';
import * as styles from './applyInterstitial.styles';

type ApplyInterstitialProps = {
  propertyId: string;
  isMobile: boolean;
};

export const ApplyInterstitial = ({ propertyId, isMobile }: ApplyInterstitialProps) => {
  const isApplyInstantlyExperiment = useSelector(
    (state: RootReduxState) =>
      state?.analytics?.runningExperiments?.[constants.HOTPADS_WEB_APPLY_INSTANTLY]?.isControl === false,
  );

  const handleApplyClick = useCallback(() => {
    emitTrackRentalAppPreStartEvent({ triggerLocation: 'home_details_halo' });
  }, []);

  const applyUrl = pathsManifest.ZillowApplicationsFlow(propertyId, {
    medium: isMobile ? 'mweb' : 'web',
    appId: uuidv4(),
    experience: isApplyInstantlyExperiment ? 'applyInstantly-exp' : 'applyInstantly-control',
  });

  return (
    <article className={styles.container} role="presentation">
      <img src={Illustration} alt="" className={styles.illustration} />

      <div className={styles.header}>
        <h2 className={styles.title}>Rental applications</h2>
        <PoweredByZillowBadge />
      </div>

      <p className={styles.body}>
        You&rsquo;re heading to Zillow to complete your application. Apply to all participating rentals for 30 days with
        one simple form &mdash; it&rsquo;s just $35.
      </p>

      <div className={styles.buttonContainer}>
        <a href={applyUrl} target="_blank" rel="noopener noreferrer" onClick={handleApplyClick}>
          <Button shape="rectangle" tone="brand" emphasis="filled" fluid={true}>
            Apply on Zillow
          </Button>
        </a>
      </div>
    </article>
  );
};
